import { useTranslation } from "react-i18next";

const useListColumns = () => {
  const { t } = useTranslation(["core"]);

  return [
    {
      Header: t("core:common.order"),
      accessor: "order",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.title"),
      accessor: "title",
    },
    {
      Header: t("core:common.publish_date"),
      accessor: "publishDate",
    },
    {
      Header: t("core:common.category"),
      accessor: "category",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.type"),
      accessor: "type",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.state"),
      accessor: "state",
      disableGlobalFilter: true,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
